import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Select,
  SelectItem,
} from '@nextui-org/react';

interface CreateExperimentModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CreateExperimentModal({
  isOpen,
  onClose,
}: CreateExperimentModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" className="text-sm">
      <ModalContent>
        <ModalHeader>
          <h2 className="text-xl">Create experiment</h2>
          {/* <p className="text-gray-500 text-sm">Evaluate and compare prompts</p> */}
        </ModalHeader>
        <ModalBody className="space-y-6">
          <div>
            <h3 className="mb-2">Tasks</h3>
            <div className="border rounded-lg p-3">Prompt A (gpt-4o)</div>
            {/* <p className="text-sm text-gray-500 mt-1">
              Each task will result in a separate experiment
            </p> */}
          </div>

          <div>
            <h3 className="mb-2">Dataset</h3>
            <Select label="Select a dataset">
              <SelectItem key="1">Dataset 1</SelectItem>
            </Select>
          </div>

          <div>
            <h3 className="mb-2">Scorers</h3>
            <Select label="Select scorers">
              <SelectItem key="1">Scorer 1</SelectItem>
            </Select>
          </div>

          {/* <Button variant="light" className="w-full justify-start">
            Advanced
          </Button> */}
        </ModalBody>
        <ModalFooter className="justify-between border-t mt-4">
          <Button variant="bordered" onPress={onClose}>
            Cancel
          </Button>
          <Button color="primary">Create</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
